// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__rUyap","wrapper__content":"Modal_wrapper__content__ySVvL","wrapper__content_message":"Modal_wrapper__content_message__VYmE9"};